module.exports = __webpack_public_path__ + "static/media/6COPUOS2.dd6f1f69.jpg";